module.exports = __webpack_public_path__ + "img/2013-12_bloomberg.69f4cc2f.jpg";